module.exports = __webpack_public_path__ + "img/ommax-voices-12.8d0bd06b.jpg";